import { KeywordBase } from "@api/useGetKeywordBaseData";
import { useMemo } from "react";
import { TableColumn } from "@components/Table/TableColumns";
import MacStageLabel from "@vms/MacStageLabel";
import { getRem } from "@datassential/platform-ui-lib";

const MAC_STAGE_COL_WIDTH = getRem(120);

export function useMacStageTableCell(
    data: Array<Pick<KeywordBase, 'macStage' | 'macStageTitle'>>
) {
    return useMemo(
        (): TableColumn => ({
            key: 'macStage',
            head: 'MAC Stage',
            headText: 'MAC Stage',
            Value: ({ index }) => data[index]?.macStage ? (
                <MacStageLabel
                    macStageId={data[index]?.macStage}
                    modifiers={["medium"]}
                />
            ) : <>-</>,
            valueText: (index) => `${data[index].macStageTitle}`,
            style: {
                cell: {
                    justifyContent: 'center',
                    flex: `0 0 ${MAC_STAGE_COL_WIDTH}`,
                    textAlign: 'center',
                },
            },
        }),
        [data]
    );
}